import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Profesion, TokenPayload } from '@/types';
import { CardsBlockCss } from '../../../styles';
import { jwtDecode } from 'jwt-decode';
// 🟢 Importa tu Loader
import Loader from '../../cardsBlock/loaderAndError/Loader'; // <-- ajusta la ruta según tu estructura real
import { safeFetch } from '@/api/safeFetch';

const EligeProfesionEditar = () => {
  const [userId, setUserId] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [profesiones, setProfesiones] = useState<Profesion[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setError("Token no encontrado.");
      setLoading(false);
      return;
    }

    try {
      const decodedToken: TokenPayload = jwtDecode<TokenPayload>(token);
      const username = decodedToken.username;
      setUserId(username ?? '');
      setIsAuthenticated(true);

      const fetchProfesiones = async () => {
        try {
          const response = await safeFetch(`/api/editProfesional/profesiones/${username}`, {
             headers: { Authorization: `Bearer ${token}` } }
          );

          if (!response.ok) {
            throw new Error(`HTTP ${response.status} — no se pudieron cargar las profesiones`);
          }

          const data = await response.json();
          setProfesiones(data);
        } catch (err: any) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };

      fetchProfesiones();
    } catch (err) {
      console.error('Error decoding token:', err);
      setIsAuthenticated(false);
      setLoading(false);
    }
  }, []);

  const handleCardClick = (nombre_profesion: string) => {
    if (userId) {
      navigate(`/editaDatosProfesional/${encodeURIComponent(nombre_profesion)}/${encodeURIComponent(userId)}`);
    }
  };

  // 🌀 Usa el Loader aquí
  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <p className="text-red-600 text-center mt-10">{error}</p>;
  }

  return (
    <div className="max-h-screen flex flex-col justify-center items-center overflow-hidden mt-10">
      {isAuthenticated && profesiones.length > 0 ? (
        <div className="grid xs:grid-cols-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 w-full p-12">
          {profesiones.map((profesion) => (
            <div
              key={profesion.profesion_id}
              className={`${CardsBlockCss.profesion} rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl transition`}
              onClick={() => handleCardClick(profesion.nombre_profesion)}
            >
              <img
                src={`/img/profesiones/${profesion.imagen_url || profesion.nombre_profesion}.jpg`}
                alt={profesion.nombre_profesion}
                className="object-cover w-full h-40"
                onError={(e) => (e.currentTarget.src = '/img/logo/LogoLinkServs.png')}
              />
              <div className={`${CardsBlockCss.nombreProfesion} p-2`}>
                <h2 className="text-lg font-semibold text-center xs:text-xs">{profesion.nombre_profesion}</h2>
              </div>
              <div className={`${CardsBlockCss.descripcionProfesion} p-4`}>
                <p
                  className="text-sm text-start leading-relaxed text-zinc-700"
                  dangerouslySetInnerHTML={{
                    __html: (profesion.descripcion ?? '').replace(/(\n|\r)/g, '<br/>'),
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-zinc-500">No se encontraron profesiones o no está autenticado.</p>
      )}
    </div>
  );
};

export default EligeProfesionEditar;